import React from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'

function OrderCancelMessage(props:any) {
    const handelSubmit =()=>{
    props?.setMessageShow(false)
    props?.setCancelShow(true) 
    }
  return (
    <div className="modal fade com-modal short-modal show" id="changeAddressModal" aria-labelledby="changeAddressModalLabel" aria-hidden="true" style={{display: "block"}} >
    <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="changeAddressModalLabel">{LanguageConstants?.ORDER_CANCEL}</h5>
                <button onClick={()=>props?.setMessageShow(false)} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
            </div>
            <div className="modal-body pb-0 text-start">
                <p className="modal-para mt-2">{LanguageConstants?.ORDER_CANCEL_MESSAGE}</p>
            </div>
            <div className="modal-footer">
                <button  className="round-btn m-0 w-100" onClick={()=>handelSubmit()} >{LanguageConstants?.COUNTINUE}</button>
            </div>
        </div>
    </div>
</div>
  )
}

export default OrderCancelMessage